"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPageHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ThemeProvider_1 = require("./lib/ThemeProvider");
var TextBase_1 = require("./Text/TextBase");
var useDomRect_1 = require("powerhooks/useDomRect");
var useGlobalState_1 = require("powerhooks/useGlobalState");
var id_1 = require("tsafe/id");
var useConstCallback_1 = require("powerhooks/useConstCallback");
var Icon_1 = require("./Icon");
var IconButton_1 = require("./IconButton");
var CloseSharp_1 = __importDefault(require("@mui/icons-material/CloseSharp"));
var SentimentSatisfied_1 = __importDefault(require("@mui/icons-material/SentimentSatisfied"));
var CollapsibleWrapper_1 = require("./CollapsibleWrapper");
var compat_1 = require("tss-react/compat");
var assert_1 = require("tsafe/assert");
var usePageHeaderClosedHelpers = useGlobalState_1.createUseGlobalState({
    "name": "pageHeaderClosedHelpers",
    "initialState": id_1.id([]),
    "doPersistAcrossReloads": false,
}).usePageHeaderClosedHelpers;
var LocalIcon = Icon_1.createIcon({
    "close": CloseSharp_1.default,
    "sentimentSatisfied": SentimentSatisfied_1.default,
}).Icon;
var IconButton = IconButton_1.createIconButton({ "Icon": LocalIcon }).IconButton;
function createPageHeader(params) {
    var Icon = (params !== null && params !== void 0 ? params : {
        "Icon": id_1.id(function () {
            throw new Error("never");
        }),
    }).Icon;
    var PageHeader = react_1.memo(react_1.forwardRef(function (props, ref) {
        var mainIcon = props.mainIcon, title = props.title, helpTitle = props.helpTitle, helpIcon = props.helpIcon, helpContent = props.helpContent, className = props.className, props_titleCollapseParams = props.titleCollapseParams, props_helpCollapseParams = props.helpCollapseParams, props_classes = props.classes, children = props.children, 
        //For the forwarding, rest should be empty (typewise)
        rest = __rest(props, ["mainIcon", "title", "helpTitle", "helpIcon", "helpContent", "className", "titleCollapseParams", "helpCollapseParams", "classes", "children"]);
        assert_1.assert(!children);
        //For the forwarding, rest should be empty (typewise),
        // eslint-disable-next-line @typescript-eslint/ban-types
        assert_1.assert();
        var _a = useDomRect_1.useDomRect(), helperRef = _a.ref, helperHeight = _a.domRect.height;
        var _b = (function useClosure() {
            var _a = usePageHeaderClosedHelpers(), pageHeaderClosedHelpers = _a.pageHeaderClosedHelpers, setPageHeaderClosedHelpers = _a.setPageHeaderClosedHelpers;
            var isHelpClosed = pageHeaderClosedHelpers.includes(title);
            var closeHelp = useConstCallback_1.useConstCallback(function () {
                return setPageHeaderClosedHelpers(__spreadArray(__spreadArray([], __read(pageHeaderClosedHelpers)), [
                    title,
                ]));
            });
            return { isHelpClosed: isHelpClosed, closeHelp: closeHelp };
        })(), isHelpClosed = _b.isHelpClosed, closeHelp = _b.closeHelp;
        var _c = useStyles({
            helperHeight: helperHeight,
        }), classes = _c.classes, cx = _c.cx;
        classes = compat_1.useMergedClasses(classes, props_classes);
        var titleCollapseParams = react_1.useMemo(function () {
            var _a;
            var titleCollapseParams = props_titleCollapseParams !== null && props_titleCollapseParams !== void 0 ? props_titleCollapseParams : id_1.id({
                "behavior": "controlled",
                "isCollapsed": false,
            });
            titleCollapseParams.classes = __assign(__assign({}, titleCollapseParams.classes), { "bottomDivForSpacing": cx(classes.titleBottomDivForSpacing, (_a = titleCollapseParams.classes) === null || _a === void 0 ? void 0 : _a.bottomDivForSpacing) });
            return { titleCollapseParams: titleCollapseParams };
        }, [
            props_titleCollapseParams,
            cx,
            classes.titleBottomDivForSpacing,
        ]).titleCollapseParams;
        var helpCollapseParams = react_1.useMemo(function () {
            var _a;
            var helpCollapseParams = isHelpClosed
                ? {
                    "behavior": "controlled",
                    "isCollapsed": true,
                }
                : props_helpCollapseParams !== null && props_helpCollapseParams !== void 0 ? props_helpCollapseParams : {
                    "behavior": "controlled",
                    "isCollapsed": false,
                };
            helpCollapseParams.classes = __assign(__assign({}, titleCollapseParams.classes), { "bottomDivForSpacing": cx(classes.helpBottomDivForSpacing, (_a = helpCollapseParams.classes) === null || _a === void 0 ? void 0 : _a.bottomDivForSpacing) });
            return { helpCollapseParams: helpCollapseParams };
        }, [
            isHelpClosed,
            props_helpCollapseParams,
            cx,
            classes.helpBottomDivForSpacing,
        ]).helpCollapseParams;
        return (jsx_runtime_1.jsxs("div", __assign({ className: cx(classes.root, className), ref: ref }, rest, { children: [jsx_runtime_1.jsx(CollapsibleWrapper_1.CollapsibleWrapper, __assign({}, titleCollapseParams, { children: jsx_runtime_1.jsxs(TextBase_1.Text, __assign({ typo: "page heading", className: classes.title }, { children: [mainIcon && (jsx_runtime_1.jsx(Icon, { iconId: mainIcon, className: classes.titleIcon, size: "large" }, void 0)), title] }), void 0) }), void 0),
                jsx_runtime_1.jsx(CollapsibleWrapper_1.CollapsibleWrapper, __assign({}, helpCollapseParams, { children: jsx_runtime_1.jsxs("div", __assign({ ref: helperRef, className: classes.help }, { children: [helpIcon && (jsx_runtime_1.jsx("div", { children: helpIcon === "sentimentSatisfied" ? (jsx_runtime_1.jsx(LocalIcon, { iconId: "sentimentSatisfied", className: classes.helpIcon }, void 0)) : (jsx_runtime_1.jsx(Icon, { iconId: helpIcon, className: classes.helpIcon }, void 0)) }, void 0)),
                            jsx_runtime_1.jsxs("div", __assign({ className: classes.helpMiddle }, { children: [jsx_runtime_1.jsx(TextBase_1.Text, __assign({ typo: "navigation label" }, { children: helpTitle }), void 0),
                                    jsx_runtime_1.jsx(TextBase_1.Text, __assign({ typo: "body 1" }, { children: helpContent }), void 0)] }), void 0),
                            jsx_runtime_1.jsx("div", { children: jsx_runtime_1.jsx(IconButton, { iconId: "close", onClick: closeHelp, className: classes.closeButton }, void 0) }, void 0)] }), void 0) }), void 0)] }), void 0));
    }));
    return { PageHeader: PageHeader };
}
exports.createPageHeader = createPageHeader;
var useStyles = ThemeProvider_1.makeStyles({ "name": "PageHeader" })(function (theme, _a) {
    var helperHeight = _a.helperHeight;
    return ({
        "root": {
            "backgroundColor": "inherit",
        },
        "title": {
            "display": "flex",
            "alignItems": "center",
        },
        "titleIcon": {
            "marginRight": theme.spacing(3),
        },
        "help": {
            "display": "flex",
            "backgroundColor": theme.colors.useCases.surfaces.surface2,
            "alignItems": "start",
            "padding": theme.spacing(3),
            "borderRadius": helperHeight * 0.15,
        },
        "helpMiddle": {
            "flex": 1,
        },
        "helpIcon": {
            "marginRight": theme.spacing(3),
            "color": theme.colors.useCases.typography.textFocus,
        },
        "closeButton": {
            "padding": 0,
            "marginLeft": theme.spacing(3),
        },
        "titleBottomDivForSpacing": {
            "height": theme.spacing(4),
        },
        "helpBottomDivForSpacing": {
            "height": theme.spacing(3),
        },
    });
});
//# sourceMappingURL=PageHeader.js.map